var map = {
	"./agentambassador/images/recipients_root_background.jpg": 258,
	"./amal/images/recipients_root_background.jpg": 259,
	"./fusionremit/images/recipients_root_background.jpg": 260,
	"./paymenta/images/recipients_root_background.jpg": 261,
	"./paymenta_sa/images/recipients_root_background.jpg": 262,
	"./payquik/images/recipients_root_background.jpg": 263,
	"./sahaltransfer/images/recipients_root_background.jpg": 264,
	"./skandsom/images/recipients_root_background.jpg": 265,
	"./vivaremit/images/recipients_root_background.jpg": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;